<template>
    <div>
        <div class="g-table-wrapper">
            <div class="table-title">
                Opgaver under "{{ type }}"
            </div>
            <vue-good-table
                :columns="columns"
                :rows="rows"
                :search-options="searchOptions"
                :pagination-options="paginationOptions"
                :sort-options="sortOptions"
                :styleClass="styleClass"
            >
                <div slot="emptystate">
                    Ingen data ...
                </div>
                <template slot="table-row" slot-scope="props">
                    <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                        {{ props.row.coverage_percent | coveragePercent }} 
                        <div
                            v-if="props.row.coverage_percent !== null"
                            class="coverage-indicator"
                            :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                        />
                    </div>
                    <div v-else-if="props.column.field == 'case_number'" class="table-column__ordernumber" style="text-align:left;white-space:nowrap;">
                        {{ props.row.case_number }}
                        <minuba-budget-tooltip :closed="true" :project="props.row" v-if="props.row.minuba_price && props.row.minuba_budget_id" />
                        <!--<div style="display:inline-block;position:relative;height:8px;width:50px;background:#ddd;border-radius:100px;overflow:hidden;box-shadow:0px 5px 15px rgba(0,0,0,0.15);" v-if="props.row.minuba_price && props.row.minuba_budget_id && $auth.user().roles[0].name === 'super-admin' && props.row.completion_rate">
                            <div :style="`height:8px;background:${props.row.completion_rate > 99 ? '#FF5252' : '#4CAF50'};width:${Math.ceil((50 / 100) * props.row.completion_rate)}px;max-width:50px;`">&nbsp;</div>
                        </div>-->
                    </div>
                    <div v-else-if="props.column.field == 'description'" class="table-column__description" :title="props.row.description">
                        <!--<d-tooltip placement="left" :space="true" :content="props.row.description" />-->
                        {{ props.row.description }}
                    </div>
                    <div v-else-if="props.column.field == 'customer.name'" class="table-column__customer" :title="props.row.customer ? props.row.customer.name : '-'">
                        <i class="fal fa-map-marker-alt" style="margin-left:2px;" v-tooltip="{
                            content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
                        }" v-if="props.row.installation_address"></i>
                        {{ props.row.customer ? props.row.customer.name : '-' }}
                    </div>
                    <div v-else-if="props.column.field == 'invoices_total'">
                        {{ props.row.invoices_total | currency}}
                    </div>
                    <div v-else-if="props.column.field == 'timelog_hours'">
                        {{ props.row.timelog_hours | number }}
                    </div>
                    <div v-else-if="props.column.field == 'coverage'">
                        <project-tooltip :project="props.row" />
                        {{ props.row.coverage | currency}}
                    </div>
                    <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                        {{ props.row.coverage_per_hour | currency }} 
                        <div
                            v-if="props.row.coverage_per_hour !== null"
                            class="coverage-indicator"
                            :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                        />
                    </div>
                    <div v-else-if="props.column.field == 'action'" class="g-table__action" @click="openExternalLink(props.row.external_id)">
                        <i class="fad fa-eye" />
                    </div>
                    <div v-else-if="props.column.field == 'start_date'">
                        {{ props.row.start_date | moment("DD. MMM YYYY") }}
                    </div>
                    <div v-else-if="props.column.field == 'type.name'" class="table-column__description" :title="props.row.type ? props.row.type.name : '-'">
                        {{ props.row.type ? props.row.type.name : '-' }}
                    </div>
                    <div v-else-if="props.column.field == 'minuba_external_id'">
                        <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                            <i class="fas fa-eye"></i>
                        </a>
                    </div>
                    <div v-else :title="props.formattedRow[props.column.field]">
                        {{ props.formattedRow[props.column.field] }}
                    </div>
                </template>
            </vue-good-table>   
        </div>
    </div>
</template>

<script>
    export default {
        props: ['rows', 'type'],
        data () {
            return {
                columns: [
                    { label: 'Ordre', field: 'case_number', type: 'number' },
                    { label: 'Opgavetype', field: 'type.name', type: 'string' },
                    { label: 'Opgave', field: 'description', type: 'string', width: '20%' },
                    { label: 'Kunde', field: 'customer.name', type: 'string' },
                    { label: 'Installationsadresse', field: 'installation_address.full_text', type: 'string' },
                    { label: 'Startdato', field: 'start_date', type: 'string' },
                    { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                    { label: 'DB', field: 'coverage', width: '10%', type: 'number' },
                    { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' },
                    { label: 'Antal timer', field: 'timelog_hours', type: 'number' },
                    { label: 'DB pr. time', field: 'coverage_per_hour', width: '8%', type: 'number' }
                ],
                searchOptions: {
                    enabled: true,
                    trigger: 'enter',
                    placeholder: 'Søg og tryk enter ...',
                    skipDiacritics: true
                },
                paginationOptions: {
                    enabled: true,
                    perPage: 30,
                    rowsPerPageLabel: 'Rækker pr. side',
                    allLabel: 'Alle',
                    nextLabel: 'Næste',
                    prevLabel: 'Forrige',
                    ofLabel: 'af',
                    pageLabel: 'side'
                },
                sortOptions: {
                    enabled: true,
                    initialSortBy: {
                        field: 'coverage',
                        type: 'desc'
                    }
                },
                styleClass: 'vgt-table',
                params: {
                    'filter[status]': 'billed,posted',
                    'include': 'customer,type,installationAddress'
                }
            }
        },
        created () {
            if (this.$auth.user().company.api_provider.slug === 'minuba') {
                this.columns.push({ label: 'Åbn', field: 'minuba_external_id' })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// minubaBudgetSingleProjects.vue?e11c19c0